// extracted by mini-css-extract-plugin
module.exports = {"photo":"FeedPhotosItem_photo__2wpy7","visualizacao":"FeedPhotosItem_visualizacao__3gh20"};